import { RestClient } from './RestClient'

export class AddressSuggestion extends RestClient {
  /**
   * SearchClient constructor
   *
   * @constructor
   */
  constructor () {
    super()

    this.baseUrl = `/addresses/suggest`
  }

  /**
   *
   * @param {string} query - Search query
   */
  search (query) {
    this.params.q = query

    return this.call('get', this.baseUrl)
  }
}
